import { render } from "./ResourceSearch.vue?vue&type=template&id=c9d55c8a"
import script from "./ResourceSearch.vue?vue&type=script&lang=js"
export * from "./ResourceSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__